









import CommonBase from "./CommonBase";
import {Component, Prop} from "vue-property-decorator";
import TitledRoute from "../modules/TitledRoute";
import {Route} from "vue-router";

@Component
export default class Breadcrumbs extends CommonBase {
    @Prop({default: () => []})
    routes!: TitledRoute[];

    static normalizedRoutePath(route: Route): string {
        let path = route.path;

        for(const paramName in route.params) {
            const v = route.params[paramName];
            path = path.replace(v, `:${paramName}`);
        }
        return path;
    }

    get breadcrumbs() {
        // get breadcrumbs to display based on router state
        const route = this.$route;

        const normalizedRoutePathArr = Breadcrumbs.normalizedRoutePath(route).split("/");

        // generate breadcrumb array with all parent routes and the active routes based on path matching, sorted on route path length
        const breadcrumbRoutes = this.routes.filter((r) => r.path.length > 0).filter((r) => r.path.split("/").every((elem, idx) => elem == normalizedRoutePathArr[idx])).sort((r1, r2) => r1.path.length - r2.path.length);
        if(breadcrumbRoutes.length === 1) {
            // If current path is the root path, return empty. Don't want to display just a single breadcrumb item.
            return [];
        }
        const breadcrumbs = breadcrumbRoutes.map((r, i, self) => {
            const title = r.meta && r.meta.title || undefined;
            if(r.name) {
                return {text: title, href: {name: r.name, query: route.query, idx: i}};
            } else {
                return {text: title, href: {path: r.path, query: route.query, idx: i}};
            }
        });
        return breadcrumbs;
    }

    get showBreadcrumbs() {
        return this.breadcrumbs.length > 0 || this.$vuetify.breakpoint.smAndUp;
    }

    created() {
        if(this.routes.length == 0) {
            throw new Error("routes property not set, no breadcrumbs will show");
        }
    }
}
